import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, JobWithCompanyResponse } from "@/types";

export function useGetJobWithCompany({
  companyId,
  jobId,
}: {
  companyId: string;
  jobId: string;
}) {
  return useQuery({
    queryKey: ["job/with-company", companyId, jobId],
    queryFn: async () => {
      const path = `companies/${companyId}/jobs/${jobId}/with-company`;
      const res = await guacHttpClient.get<
        JobWithCompanyResponse,
        HttpResponse<JobWithCompanyResponse>
      >(path);
      return res.data;
    },
  });
}
